import Cookies from "js-cookie";
import { apiRequest } from "../Component/Utils/ApiHundler";
const API_BASE_URL = process.env.REACT_APP_API_URL;

export async function getJdataADM(instanceId, docId, token, ClientId) {
  const apiUrl = `${API_BASE_URL}/admin/document/query`;

  const data = await apiRequest(apiUrl, {
    method: "POST",
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ DocumentId: docId, InstanceId: instanceId, ClientId: ClientId }),
  });

  displayFormattedJSON(data.message);
  return data.message.Data;
}

const displayFormattedJSON = (jsonData) => {
  const existingModals = document.querySelectorAll("#input-modal, #json-modal");
  existingModals.forEach((modal) => modal.remove());

  if (document.getElementById("json-modal")) return;

  const modal = document.createElement("div");
  modal.id = "json-modal";
  modal.style.position = "fixed";
  modal.style.top = "0";
  modal.style.left = "0";
  modal.style.width = "100%";
  modal.style.height = "100%";
  modal.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
  modal.style.display = "flex";
  modal.style.alignItems = "center";
  modal.style.justifyContent = "center";
  modal.style.zIndex = "9999";

  const jsonContainer = document.createElement("pre");
  jsonContainer.style.backgroundColor = "#333333";
  jsonContainer.style.color = "#ffffff";
  jsonContainer.style.padding = "20px";
  jsonContainer.style.overflow = "auto";
  jsonContainer.style.maxWidth = "80%";
  jsonContainer.style.maxHeight = "80%";
  jsonContainer.style.borderRadius = "5px";
  jsonContainer.style.boxShadow = "0 0 10px rgba(0, 0, 0, 0.3)";
  jsonContainer.textContent = JSON.stringify(jsonData, null, 2);

  modal.appendChild(jsonContainer);

  document.body.appendChild(modal);

  modal.addEventListener("click", (event) => {
    if (event.target === modal) {
      document.body.removeChild(modal);
    }
  });
};

// Récupère les données (utilisée pour le téléchargement)
export async function fetchJDataADM(instanceId, docId, token, ClientId) {
  const apiUrl = `${API_BASE_URL}/admin/document/query`;

  const data = await apiRequest(apiUrl, {
    method: "POST",
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ DocumentId: docId, InstanceId: instanceId, ClientId: ClientId }),
  });

  return data.message.Data;
}